/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { termsEditorActionEditor } from "./actionEditor";
import { termsEditorEndpointEditor } from "./endpointEditor";
import { termsEditorCategories } from "./categories";
import { termsEditorCommon } from "./common";
import { termsEditorInspector } from "./inspector";
import { termsEditorViewEditor } from "./viewEditor";
import { termsEditorThemeEditor } from "./themeEditor";

export const termsEditor = {
	common: termsEditorCommon,
	categories: termsEditorCategories,
	inspector: termsEditorInspector,
	viewEditor: termsEditorViewEditor,
	actionEditor: termsEditorActionEditor,
	endpointEditor: termsEditorEndpointEditor,
	themeEditor: termsEditorThemeEditor
};
